import { useState } from 'react'
import type { AccountDetail } from '../../../api/accounts'
import { api } from '../../../api/client'
import { formatDate } from '../../../lib/format'
import { useAccountAction } from './useAccountAction'

/** Access we gave rather than sold: add one with an optional end date, or end one now. */
export function GrantsCard({ accountId, grants }: { accountId: string; grants: AccountDetail['grants'] }) {
	const [until, setUntil] = useState('')
	const [note, setNote] = useState('')
	const add = useAccountAction(accountId, () =>
		api
			.post(`/api/v1/admin/accounts/${accountId}/grants`, {
				expiresAt: until ? new Date(until).toISOString() : null,
				note: note.trim() || null,
			})
			.then(() => setNote('')),
	)
	const revoke = useAccountAction(accountId, (grantId: string) =>
		api.delete(`/api/v1/admin/accounts/${accountId}/grants/${grantId}`),
	)

	return (
		<section className="card stack">
			<h2 style={{ margin: 0 }}>Grants</h2>
			{grants.map((g) => (
				<div key={g.id} className="row" style={{ opacity: g.revokedAt ? 0.6 : 1 }}>
					<span style={{ flex: 1 }} className="small">
						{g.plan} ({g.source}) from {formatDate(g.startsAt)}{' '}
						{g.expiresAt ? `until ${formatDate(g.expiresAt)}` : 'with no end date'}
						{g.note && <span className="muted"> · {g.note}</span>}
						{g.revokedAt && <span className="muted"> · ended {formatDate(g.revokedAt)}</span>}
					</span>
					{!g.revokedAt && (
						<button type="button" onClick={() => revoke.mutate(g.id)}>
							End now
						</button>
					)}
				</div>
			))}
			<form className="row" style={{ flexWrap: 'wrap' }} onSubmit={(e) => (e.preventDefault(), add.mutate(undefined))}>
				<label className="small row">
					Pro until
					<input type="date" aria-label="Grant until" value={until} onChange={(e) => setUntil(e.target.value)} />
				</label>
				<input
					aria-label="Grant note"
					placeholder="Why"
					value={note}
					onChange={(e) => setNote(e.target.value)}
					style={{ flex: 1, minWidth: '10rem' }}
				/>
				<button type="submit" disabled={add.isPending}>
					Grant
				</button>
			</form>
			{(add.error ?? revoke.error) && <p className="error small">{(add.error ?? revoke.error)!.message}</p>}
		</section>
	)
}
